module.exports = __webpack_public_path__ + "img/bxc-ylb.0cc414cd.jpg";